import { render } from "./HeroiconsSolidViewGridAdd.vue?vue&type=template&id=3fa9168f"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidViewGridAdd.vue"]])

export default __exports__